import { Badge, BottomNavigationAction, useTheme } from '@mui/material';
import { JSX } from 'react';

import { ConditionalWrap } from '@frontend-libs/atomic';
import { AppAdaptedTooltip, PortalTheme } from '@frontend-libs/portal';

export interface AppBottomNavbarActionProps {
  label: string;
  value: string;
  icon: JSX.Element;
  onClick: () => void;
  count?: number;
  disabled?: boolean;
}

export const AppBottomNavbarAction = (props: AppBottomNavbarActionProps) => {
  const theme = useTheme<PortalTheme>();

  return (
    <AppAdaptedTooltip title={props.label}>
      <BottomNavigationAction
        showLabel
        component="a"
        value={props.value}
        label={props.label}
        disabled={props.disabled}
        data-eventid={`app-bottom-navbar-${props.label.toLowerCase()}`}
        slotProps={{
          label: {
            sx: {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              width: '100%',
              maxWidth: '100%',
              textAlign: 'center',
            },
          },
          root: {
            sx: {
              opacity: props.disabled ? 0.38 : 1,
            },
          },
        }}
        sx={{
          minWidth: '60px',
          px: 0.25,
          maxWidth: '120px',
        }}
        onClick={props.onClick}
        icon={
          <ConditionalWrap
            condition={!!props.count}
            wrap={(children) => (
              <Badge
                badgeContent={props.count}
                invisible={!props.count}
                sx={{
                  '& .MuiBadge-badge': {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    border: `2px solid ${theme.palette.background.paper}`,
                  },
                }}
              >
                {children}
              </Badge>
            )}
          >
            {props.icon}
          </ConditionalWrap>
        }
      />
    </AppAdaptedTooltip>
  );
};
